import { defaults } from 'react-chartjs-2';
import { Colors } from '../../..';
const {
  plum_dark
} = Colors;
defaults.font.weight = 'bold';
defaults.font.size = 11;
const fontStyles = {
  weight: 'bold',
  size: 16
};
const toolTipStyles = {
  backgroundColor: plum_dark
};
const labelStyles = {
  borderWidth: 0,
  borderRadius: 2
};
export { defaults, fontStyles, toolTipStyles, labelStyles };